import { render } from "./PrintSetupDialog.vue?vue&type=template&id=91581a46&scoped=true&ts=true"
import script from "./PrintSetupDialog.vue?vue&type=script&lang=ts"
export * from "./PrintSetupDialog.vue?vue&type=script&lang=ts"

import "./PrintSetupDialog.vue?vue&type=style&index=0&id=91581a46&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91581a46"]])

export default __exports__